import { render } from "./CompanyCreatePage.vue?vue&type=template&id=61a5e901"
import script from "./CompanyCreatePage.vue?vue&type=script&lang=js"
export * from "./CompanyCreatePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__